import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SidebarItem } from './sidebar-item.interface';
import { SidebarItem as SidebarItemEnum } from 'src/shared/enums/app/sidebar-item.enum';
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private _activeItem$ = new BehaviorSubject<any>(undefined);
  private _activeSubItem$ = new BehaviorSubject<any>(undefined);
  private _isExpandSidebar$ = new BehaviorSubject<boolean>(false);
  private _isExpandOnHoverSidebar$ = new Subject<boolean>();
  private _isSidebarVisible = new BehaviorSubject<boolean>(false);

  setActiveItem(item) {
    this._activeItem$.next(item);
  }

  getActiveItem() {
    return this._activeItem$.asObservable();
  }

  setActiveISubtem(item) {
    this._activeSubItem$.next(item);
  }

  getActiveSubItem() {
    return this._activeSubItem$.asObservable();
  }

  expandSidebar(expand = true) {
    this._isExpandSidebar$.next(expand);
  }

  getExpandSidebarObs() {
    return this._isExpandSidebar$.asObservable();
  }

  expandOnHoverSidebar(expand = true) {
    this._isExpandOnHoverSidebar$.next(expand);
  }

  getExpandOnHoverSidebarObs() {
    return this._isExpandOnHoverSidebar$.asObservable();
  }

  setSidebarVisibility(isVisible: boolean) {
    this._isSidebarVisible.next(isVisible);
  }

  isSideBarVisibleObs() {
    return this._isSidebarVisible.asObservable();
  }

  public handleInitActiveSidebar(
    url: string,
    sidebarItems: Array<SidebarItem>
  ) {
    let currentItem;
    let currentSubItem;
    sidebarItems.forEach((item) => {
      if (item.isHadSub) {
        const sub = item.sub.filter((i) => {
          return this.isSameMainPathName(url, i.routerLink);
        });
        if (sub.length) {
          const param = this.getRouterParam(url);
          currentSubItem =
            sub.length === 1
              ? sub[0]
              : sub.find((menu) => menu.routerParams?.type === param);
          currentItem = item;
        }
      } else if (!currentItem &&  this.isSameMainPathName(url, item.routerLink)) {
        currentItem = item;
      }
    });
    if (currentSubItem) {
      return [currentItem.item, currentSubItem.item];
    }
    return [currentItem?.item || SidebarItemEnum.DASHBOARD, null];
  }

  private getRouterParam(url: string): string {
    const stringSplit = url.split('=', 2);
    if (stringSplit.length === 2) {
      return stringSplit[1];
    } else {
      return '';
    }
  }

  private isSameMainPathName(currentUrl, routerLinkUrl): boolean {
    const tempStr1 = currentUrl.split('/');
    const tempStr2 = routerLinkUrl.split('/');
    return tempStr1[1] === tempStr2[1]; // fix issue, ex: distinguish  URL "abc" vs "abc-xxx"
  }
}
